import React from 'react'
import './TaskList.css';
import AcceptTask from './AcceptTask';
import NewTask from './NewTask';
import Complete from './Complete';
import Failed from './Failed';
function TaskList({data, setLoggedInUserData}) {
  return (
    <div className='mt-4'>
        <div className='container'>
            <div className='row tasklist'> 
            { data && 
                data.tasks.map((elem,index)=>{
                   if(elem.newTask){
                    return <NewTask key={index}  elem={elem} data={data} setLoggedInUserData={setLoggedInUserData}/>
                   }
                   if(elem.completed){
                    return <Complete key={index}  elem={elem} />
                   }
                   if(elem.active){
                    return <AcceptTask key={index} elem={elem} data={data} setLoggedInUserData={setLoggedInUserData}/>
                   }
                   if(elem.failed){
                    return <Failed key={index} elem={elem} />
                   }
                   return null
                })
            } 
            </div>
        </div>
    </div>
  )
}

export default TaskList;